(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderCar',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.success = function success(response)
	{
		var form_data,
			component_index,
			start_date,
			start_time,
			start_date_time,
			end_date,
			end_time,
			end_date_time,
			modal_start_date,
			modal_start_time,
			modal_start_date_time,
			modal_end_date,
			modal_end_time,
			modal_end_date_time;

		if ($('#fitbuildercar-adding').val() === '1') {
			if (!Adzuki.Form.hasError(response)) {
				if ($('#fit-builder-component-index')) {
					component_index  = $('#fit-builder-component-index').val();
					start_date       = $('#start-date-' + component_index + '_hidden');
					start_time       = $('#start-date-' + component_index + '-time_hidden');
					end_date         = $('#end-date-' + component_index + '_hidden');
					end_time         = $('#end-date-' + component_index + '-time_hidden');
					modal_start_date = $('#fitbuildercar-pickup_time-date_hidden');
					modal_start_time = $('#fitbuildercar-pickup_time-time_hidden');
					modal_end_date   = $('#fitbuildercar-dropoff_time-date_hidden');
					modal_end_time   = $('#fitbuildercar-dropoff_time-time_hidden');

					// build full date/time strings
					start_date_time       = start_date.val() + ' ' + start_time.val();
					end_date_time         = end_date.val() + ' ' + end_time.val();
					modal_start_date_time = modal_start_date.val() + ' ' + modal_start_time.val();
					modal_end_date_time   = modal_end_date.val() + ' ' + modal_end_time.val();

					// format them
					start_date_time       = moment(start_date_time).format('YYYY-MM-DD HH:mm');
					end_date_time         = moment(end_date_time).format('YYYY-MM-DD HH:mm');
					modal_start_date_time = moment(modal_start_date_time).format('YYYY-MM-DD HH:mm');
					modal_end_date_time   = moment(modal_end_date_time).format('YYYY-MM-DD HH:mm');

					if (start_date_time !== modal_start_date_time) {
						// start date/time between component and details doesn't match, update component in form
						$('#start-date-' + component_index).data("DateTimePicker").date(moment(modal_start_date_time));
						$('#start-date-' + component_index + '-time').data("DateTimePicker").date(moment(modal_start_date_time));
					}

					if (end_date_time !== modal_end_date_time) {
						// end date/time between component and details doesn't match, update component in form
						$('#end-date-' + component_index).data("DateTimePicker").date(moment(modal_end_date_time));
						$('#end-date-' + component_index + '-time').data("DateTimePicker").date(moment(modal_end_date_time));
					}
				}

				form_data = $('#fit-builder-car').serialize();

				$('#saved_details_' + component_index).val(form_data);
				$('#fit-builder-details-type-message-' + component_index).removeClass('hidden');
				$('.fit-builder-detail-link[data-i="' + component_index + '"]').addClass('hidden');

				$('.modal').modal('hide');
			}
		} else {
			// eslint-disable-next-line no-lonely-if
			if (!Adzuki.Form.hasError(response)) {
				window.location.href = response['data'];
				return true;
			}
		}
	};
}(jQuery, window.Adzuki || {}));